/* eslint-disable camelcase, no-undef */

function getCurrentScriptSrc () {
  if (typeof document === 'undefined') {
    return ''
  }

  if (document.currentScript && document.currentScript.src) {
    return document.currentScript.src
  }

  const scripts = document.getElementsByTagName('script')

  if (!scripts.length) {
    return ''
  }

  for (let index = scripts.length - 1; index >= 0; index -= 1) {
    const src = scripts[index].src || scripts[index].getAttribute('src')

    if (src && /static\/js\//.test(src)) {
      return src
    }
  }

  const lastScript = scripts[scripts.length - 1]

  return lastScript ? (lastScript.src || lastScript.getAttribute('src') || '') : ''
}

function resolveAssetBaseFromScript (scriptSrc) {
  if (!scriptSrc) {
    return ''
  }

  const normalizedSrc = scriptSrc.replace(/[#?].*$/, '')
  const match = normalizedSrc.match(/^(.*?)(?:static\/js\/[^/]+)$/)

  return match ? match[1] : ''
}

function resolveAssetBaseFromLocation () {
  if (typeof window === 'undefined') {
    return ''
  }

  if (window.location.protocol === 'file:') {
    const pathname = (window.location.pathname || '').replace(/\\/g, '/')
    const distMarker = '/dist/'
    const markerIndex = pathname.toLowerCase().lastIndexOf(distMarker)

    if (markerIndex !== -1) {
      return window.location.href
        .replace(/[#?].*$/, '')
        .replace(/\\/g, '/')
        .replace(pathname, pathname.slice(0, markerIndex + distMarker.length))
    }
  }

  return (window.location.origin || '') + '/'
}

const assetBase = resolveAssetBaseFromScript(getCurrentScriptSrc()) || resolveAssetBaseFromLocation()

if (assetBase) {
  __webpack_public_path__ = assetBase
}



// WEBPACK FOOTER //
// ./src/set-public-path.js